// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';

// ANTD
import Button from 'antd/lib/button';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import notification from 'antd/lib/notification';

// APOLLO
import { graphql, compose } from 'react-apollo';
import CURRENT_USER from 'ApolloClient/Queries/currentUser';
import GET_PAYPAL_AUTH_URL from 'ApolloClient/Mutations/getPaypalAuthUrl';
import REVOKE_PAYPAL_ACCESS from 'ApolloClient/Mutations/revokePaypalAccess';
// import Raven from 'raven-js';

const styles = {
  container: {
    border: '1px solid #efefef',
    borderLeft: '5px solid #179bd8',
    minHeight: 100,
    padding: 15,
    width: 550,
    maxWidth: '100%',
    marginTop: 15,
  },
};

// See:
// https://developer.paypal.com/docs/integration/direct/identity/get-user-consent/
// https://developer.paypal.com/docs/integration/direct/identity/log-in-with-paypal/
class PaypalConnect extends React.PureComponent {
  state = {
    disabled: false, // whether or not the form submit button is disabled
  };

  disableBtn = () => {
    this.setState({ disabled: true });
  };

  enableBtn = () => {
    this.setState({ disabled: false });
  };

  handleAuth = async () => {
    let res;
    this.disableBtn();

    try {
      res = await this.props.getPaypalAuthUrl({ variables: {} });
    } catch (exc) {
      console.log(exc);
      // Raven.captureException(exc)
      return notification.error({ message: exc });
    }

    if (!res || !res.data || !res.data.getPaypalAuthUrl || !res.data.getPaypalAuthUrl.url) {
      // console.log(exc);
      // return notification.error({ message: exc });
      return notification.error({ message: 'Something went wrong' });
    }

    // Redirect user to paypal auth page
    window.location = res.data.getPaypalAuthUrl.url;

    this.enableBtn();
  };

  handleRevoke = async () => {
    const { revokePaypalAccess } = this.props;

    this.disableBtn();

    try {
      await revokePaypalAccess({
        variables: {},
        refetchQueries: [{ query: CURRENT_USER }],
      });
      notification.success({ message: 'Paypal access revoked!' });
    } catch (exc) {
      console.log(exc);
      // Raven.captureException(exc);
      return notification.error({ message: exc });
    }

    this.enableBtn();
  };

  render() {
    const { currentUser } = this.props;

    if (!currentUser.paypalSet) {
      return (
        <a
          href=""
          onClick={evt => {
            evt.preventDefault();
            this.handleAuth();
          }}
        >
          <img
            src="https://www.paypalobjects.com/webstatic/en_US/developer/docs/lipp/loginwithpaypalbutton.png"
            alt="paypal"
          />
        </a>
      );
    }

    return (
      <div>
        <Row type="flex" align="middle" justify="center" style={styles.container}>
          <Col xs={24} sm={16} style={{ display: 'flex', justifyContent: 'flex-start', textAlign: 'left' }}>
            <img src="http://pngimg.com/uploads/paypal/paypal_PNG2.png" alt="logo" style={{ maxHeight: 65 }} />
            {/* <a>DEAUTHORIZE ACCOUNT</a> */}
          </Col>
          <Col xs={24} sm={8} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a target="_blank" href="https://www.paypal.com/myaccount/home">
              <Button size="large" style={{ background: '#179bd8', color: 'white' }}>
                VIEW PAYPAL DASHBOARD
              </Button>
            </a>
          </Col>
          <Col xs={24} />
        </Row>
        <a
          href=""
          onClick={evt => {
            evt.preventDefault();
            this.handleRevoke();
          }}
        >
          Revoke HeyNed Access
        </a>
      </div>
    );
  }
}

PaypalConnect.propTypes = {
  currentUser: PropTypes.object.isRequired, // eslint-disable-line
  getPaypalAuthUrl: PropTypes.func.isRequired,
  revokePaypalAccess: PropTypes.func.isRequired,
};

const enhance = compose(
  graphql(GET_PAYPAL_AUTH_URL, { name: 'getPaypalAuthUrl' }),
  graphql(REVOKE_PAYPAL_ACCESS, { name: 'revokePaypalAccess' }),
);

export default enhance(PaypalConnect);



// WEBPACK FOOTER //
// ./src/routes/app-studio/PaymentsArea/PaypalConnect.js